// extracted by mini-css-extract-plugin
module.exports = {"info":"Profile_info__3Vv7X","icons":"Profile_icons__8o3PB","container":"Profile_container__5IaRP"};